import { MenuModel } from './../../shared/definition/menu.model';

import { LogService } from './log.service';
import { environment } from './../../environments/environment.prod';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  // 项目名称
  pid = environment.production
  constructor(
    private messageService: NzMessageService
  ) {
  }
  /**
   * @description: 获取菜单信息
   * @param {type} []
   * @return:  []
   */
  getMenus() {
    return []
  }
  /**
   * 跳转路由
   * @param menu
   */
  navMenu(router: Router, menu: MenuModel, refresh?: string) {
    if (refresh === undefined) {
      refresh = 'Y'
    }
    let params = {
      queryParams: {
        refresh: refresh,
        ID: menu.id,
        MENUID: menu.enCode,
        MENUNAME: menu.name,
        MENUICON: menu.icon,
        MENUTYPE: "APP",
        ROUTER: menu.urlAddress,
        PID: menu.parent,
        APPID: "",
        PARAM: ""
      }
    }
    LogService.debug(params);
    router
      .navigate([menu.urlAddress])
      .then(() => {
      })
      .catch(error => {
        router.navigate(['/error'])
      })
  }
}
